<div class="aplayer-lrc">
  <div class="aplayer-lrc-contents" :style="transform">
    <template v-if="lrc">
      <p v-if="LRC.length <= 0">(*ゝω・) 少女祈祷中..</p>
      <p v-else :class="{ 'aplayer-lrc-current': current.time === lrc.time }" ref="lrc" v-for="(lrc, index) in LRC" :data-index="index" :data-time="lrc.time">{{ lrc.text }}</p>
    </template>
    <p v-else class="aplayer-lrc-current">(,,•́ . •̀,,) 抱歉，当前歌曲暂无歌词</p>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/Lyric/src/Lyric.html